import type { CSSProperties } from 'react'

export const TypographyVariantsConstants = [
  'Poppins/H1',
  'Poppins/H1 - Medium',
  'Poppins/H2',
  'Poppins/H2 - Medium',
  'Poppins/H3',
  'Poppins/H3 - Medium',
  'Poppins/H4',
  'Poppins/H4 - Medium',
  'Poppins/T1',
  'Poppins/T1 - Medium',
  'Poppins/T1 - Semibold',
  'Poppins/T2',
  'Poppins/T2 - Medium',
  'Poppins/T2 - Semibold',
  'Poppins/T3',
  'Poppins/T3 - Medium',
  'Poppins/T3 - Semibold',
  'Poppins/T4',
  'Poppins/T4 - Medium',
  'Poppins/T4 - Semibold',
  'Poppins/T5',
  'Poppins/T5 - Medium',
] as const

export type TypographyVariants = (typeof TypographyVariantsConstants)[number]

export type TypographyProps = {
  $color?: string
  $textAlign?: CSSProperties['textAlign']
  $variant: TypographyVariants
}

export enum TypographyBreakpoint {
  largeMobile = 376,
  desktop = 768,
}
